// extracted by mini-css-extract-plugin
export default {"header":"Header_header__vf2Lk","header-text":"Header_header-text__F5BDO","header-text1":"Header_header-text1__JP9cm"};